<div #hostEl class="status-legend" (click)="$event.stopPropagation()">
  <span class="status-legend__heading">Legenda de status</span>
  @for (node of nodes; track trackByNode($index, node)) {
    <div class="status-legend__node" [class.status-legend__node--open]="openKey === node.key">
      @if (node.type === 'group') {
        <button type="button" class="status-legend__pill" (click)="toggle(node.key, $event)">
          <span class="status-legend__dot" [style.background-color]="node.group!.color"></span>
          <span class="status-legend__label">{{ node.group!.label }}</span>
          <span class="material-symbols-outlined status-legend__caret">
            {{ openKey === node.key ? 'expand_less' : 'expand_more' }}
          </span>
        </button>
        @if (openKey === node.key) {
          <div class="status-legend__popover">
            <ul class="status-legend__list">
              @for (item of node.items; track trackByItem($index, item)) {
                <li class="status-legend__list-item">
                  <span class="status-legend__list-dot" [style.background-color]="node.group!.color"></span>
                  <span class="status-legend__list-name">{{ item.name }}</span>
                </li>
              }
            </ul>
          </div>
        }
      } @else {
        <button type="button" class="status-legend__pill status-legend__pill--parent" (click)="toggle(node.key, $event)">
          <span class="material-symbols-outlined status-legend__folder">folder</span>
          <span class="status-legend__label">{{ node.parentLabel }}</span>
          <span class="material-symbols-outlined status-legend__caret">
            {{ openKey === node.key ? 'expand_less' : 'expand_more' }}
          </span>
        </button>
        @if (openKey === node.key) {
          <div class="status-legend__popover status-legend__popover--parent">
            @for (sub of node.childGroups; track trackBySub($index, sub)) {
              <div class="status-legend__sub" [class.status-legend__sub--open]="openSubKey === sub.group.id">
                <button type="button" class="status-legend__sub-header" (click)="toggleSub(sub.group.id, $event)">
                  <span class="status-legend__dot" [style.background-color]="sub.group.color"></span>
                  <span class="status-legend__label">{{ sub.group.label }}</span>
                  <span class="status-legend__count">{{ sub.items.length }}</span>
                  <span class="material-symbols-outlined status-legend__caret">
                    {{ openSubKey === sub.group.id ? 'expand_less' : 'expand_more' }}
                  </span>
                </button>
                @if (openSubKey === sub.group.id) {
                  <ul class="status-legend__list">
                    @for (item of sub.items; track trackByItem($index, item)) {
                      <li class="status-legend__list-item">
                        <span class="status-legend__list-dot" [style.background-color]="sub.group.color"></span>
                        <span class="status-legend__list-name">{{ item.name }}</span>
                      </li>
                    }
                  </ul>
                }
              </div>
            }
          </div>
        }
      }
    </div>
  }
</div>
